import * as Sentry from '@sentry/react'

export const logError = (error: any) => {
  Sentry.captureException(error)
}
